export default (el) => {
  const countQuestionEl = el.querySelector('.js-count-question')
  const questionEl = document.querySelector('#question')

  countQuestionEl.innerHTML = questionEl.getAttribute('data-count-question')
}
